if (!customElements.get('sh-product-description')) {
  customElements.define('sh-product-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-description-content]');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.onToggle = () => {
        const collapsing = this.hasAttribute('data-expanded');
        const aboveViewport = this.getBoundingClientRect().top < 0;
        this.setExpanded(!collapsing);
        if (collapsing && aboveViewport) this.scrollIntoView({ block: 'start', behavior: 'instant' });
      };
      // Reveal clipped links before keyboard focus reaches them.
      this.onFocus = (event) => {
        if (this.hasAttribute('data-collapsible') && !this.hasAttribute('data-expanded')) {
          this.setExpanded(true);
        }
      };
      this.scheduleMeasure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      this.button.addEventListener('click', this.onToggle);
      this.content.addEventListener('focusin', this.onFocus);
      this.content.addEventListener('load', this.scheduleMeasure, true);
      this.observer = new ResizeObserver(this.scheduleMeasure);
      this.observer.observe(this.content);
      this.contentObserver = new MutationObserver(this.scheduleMeasure);
      this.contentObserver.observe(this.content, { childList: true, subtree: true, characterData: true });
      this.scheduleMeasure();
      document.fonts?.ready.then(() => { if (this.isConnected) this.scheduleMeasure(); });
    }
    measure() {
      if (!this.isConnected || !this.content.getBoundingClientRect().width) return;
      const style = getComputedStyle(this.content);
      const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.6;
      const lines = parseFloat(getComputedStyle(this).getPropertyValue('--sh-description-lines')) || 6;
      const height = Math.ceil(lineHeight * lines);
      const heightValue = `${height}px`;
      if (this.style.getPropertyValue('--sh-description-preview-height') !== heightValue) {
        this.style.setProperty('--sh-description-preview-height', heightValue);
      }
      const long = this.content.scrollHeight > height + 12;
      this.toggleAttribute('data-collapsible', long);
      this.button.hidden = !long;
      if (!long) this.setExpanded(false);
    }
    setExpanded(expanded) {
      this.toggleAttribute('data-expanded', expanded);
      this.button.setAttribute('aria-expanded', String(expanded));
      this.button.querySelector('[data-description-more]').hidden = expanded;
      this.button.querySelector('[data-description-less]').hidden = !expanded;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.contentObserver?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
      this.content?.removeEventListener('focusin', this.onFocus);
      this.content?.removeEventListener('load', this.scheduleMeasure, true);
    }
  });
}
